import styles from 'components/Player/AudioPlayerWrapper/PlayQueue/PlayQueue.module.scss';
import { useTranslation } from 'hooks/useTranslation';
import { PlayQueueCard } from 'components/Player/AudioPlayerWrapper/PlayQueue/PlayQueueCard';
import { useFeatureFlag } from 'contexts/FeatureFlagContext/FeatureFlagContext';

type Props = {
  itemIds: string[];
  handleCheckboxChange: (
    event: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => void;
  selectedCardIndexes: number[];
};

const NextInQueueList = ({
  itemIds,
  handleCheckboxChange,
  selectedCardIndexes,
}: Props) => {
  const t = useTranslation();
  const { playQueue2024 } = useFeatureFlag();

  return (
    <div>
      <h3 className={styles.subTitle}>{t('nextInQueue')}</h3>
      {itemIds &&
        itemIds.map((itemId, i) => {
          const cardKey = `play-queue-next-in-queue-${itemId}-${i}`;
          return (
            <div key={cardKey} className={styles.cardContainer}>
              <PlayQueueCard
                itemId={itemId}
                isActive={false}
                cardKey={cardKey}
                isSimpleCard={playQueue2024}
                handleCheckboxChange={handleCheckboxChange}
                selectedCardIndexes={selectedCardIndexes}
                index={i}
              />
            </div>
          );
        })}
    </div>
  );
};

export default NextInQueueList;
